import { useEffect, useState } from 'react';
import {
    asyncGetOrbitCatalog,
    asyncGetOrbitCitiesFlat,
} from '../../../../services/orbit.service';
import { asyncGetOrbitAddressTypes } from '../address/orbitAddressTypeParams';
import { ISelect } from '../../../../shared/types/shared';
import { OrbitCatalogEnum } from '../../../../shared/types/orbit';

export type OrbitAccountLookupCatalogs = {
    genders: ISelect[];
    specialConditions: ISelect[];
    cities: ISelect[];
    addressTypes: ISelect[];
};

const EMPTY_CATALOGS: OrbitAccountLookupCatalogs = {
    genders: [],
    specialConditions: [],
    cities: [],
    addressTypes: [],
};

export const useOrbitAccountLookupCatalogs = (enabled: boolean) => {
    const [catalogs, setCatalogs] =
        useState<OrbitAccountLookupCatalogs>(EMPTY_CATALOGS);
    const [ready, setReady] = useState(!enabled);
    const [error, setError] = useState<string>();

    useEffect(() => {
        if (!enabled) {
            setCatalogs(EMPTY_CATALOGS);
            setReady(true);
            setError(undefined);
            return;
        }

        let active = true;
        setReady(false);
        setError(undefined);

        const load = async () => {
            const [
                gendersCatalog,
                specialConditionsCatalog,
                citiesCatalog,
                addressTypeParams,
            ] = await Promise.all([
                asyncGetOrbitCatalog(OrbitCatalogEnum.Genders),
                asyncGetOrbitCatalog(OrbitCatalogEnum.SpecialConditions),
                asyncGetOrbitCitiesFlat(),
                asyncGetOrbitAddressTypes(),
            ]);

            if (!active) return;

            const addressTypes = addressTypeParams;
            const catalogError =
                gendersCatalog.error ||
                specialConditionsCatalog.error ||
                citiesCatalog.error;

            if (catalogError) {
                setError(catalogError);
                setCatalogs(EMPTY_CATALOGS);
                setReady(true);
                return;
            }

            setCatalogs({
                genders: gendersCatalog.items,
                specialConditions: specialConditionsCatalog.items,
                cities: citiesCatalog.items,
                addressTypes,
            });
            setReady(true);
        };

        load();

        return () => {
            active = false;
        };
    }, [enabled]);

    return { catalogs, ready, error };
};
